import { render, staticRenderFns } from "./commodity_must_order.vue?vue&type=template&id=7d482530&scoped=true"
import script from "./commodity_must_order.vue?vue&type=script&lang=js"
export * from "./commodity_must_order.vue?vue&type=script&lang=js"
import style0 from "./commodity_must_order.vue?vue&type=style&index=0&id=7d482530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d482530",
  null
  
)

export default component.exports